<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nf_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nf Inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nf_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nf Final</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="serie"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Serie</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="usuario_imp"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Email Usuario Inc.</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="emi_razao_social"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Emissor</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="red_razao_social"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Redespacho</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Dt Emissão Inicial"
              v-model="dt_emi_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Dt Emissão Final"
              v-model="dt_emi_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Dt Importação Inicial"
              v-model="dt_imp_ini"
              class="form-control"
              @input="validateDates"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <b-form-timepicker
              v-model="hr_imp_ini"
              :state="timeState"
              locale="pt-br"
              reset-button
              label-no-time-selected="Hora"
              @input="validateDates"
              class="mb-2"
            ></b-form-timepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Dt Importação Final"
              v-model="dt_imp_fim"
              class="form-control"
              @input="validateDates"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <b-form-timepicker
              v-model="hr_imp_fim"
              :state="timeState"
              locale="pt-br"
              reset-button
              label-no-time-selected="Hora"
              @input="validateDates"
              class="mb-2"
            ></b-form-timepicker>
            <div 
              v-if="dateValidationError" 
              class="text-danger" 
              style="font-size: 10px; line-height: 1.2; position: absolute; margin-top: -14px;"
            >
              {{ dateValidationError }}
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status_importacao"
              :options="this.$parent.optionsStatusImportacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="emi_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ/CPF Origem</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="des_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ/CPF Destinatário</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="chave"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Chave de acesso NFe</label
              >
            </div>
          </b-col>
          
          <b-col sm="6" md="3" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      nf_ini: "",
      nf_fim: "",
      serie: "",
      emi_razao_social: "",
      red_razao_social: "",
      usuario_imp: "",
      dt_imp_ini: "",
      dt_imp_fim: "",
      dt_emi_ini: "",
      hr_imp_ini: "",
      dt_emi_fim: "",
      hr_imp_fim: "",
      dateValidationError: "",
      emi_cnpj: "",
      des_cnpj: "",
      status_importacao: "",
      chave: "",
      status: [],
      tp_pessoa: [],
      municipio: [],
      fornecedor: [],
      data_filter: [],
      helpForm: new Form({ statusRecord: [], params: [] })
    };
  },

  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);

      this.validateDates();
      if (this.dateValidationError) {
          this.$store.commit("setVuetableFilterButton", false);
          return;
      }

      this.data_filter = {
        nf_ini: this.nf_ini,
        nf_fim: this.nf_fim,
        serie: this.serie,
        emi_razao_social: this.emi_razao_social,
        red_razao_social: this.red_razao_social,
        usuario_imp: this.usuario_imp,
        dt_imp_ini: this.dt_imp_ini,
        dt_imp_fim: this.dt_imp_fim,
        dt_emi_ini: this.dt_emi_ini,
        hr_imp_ini: this.hr_imp_ini,
        dt_emi_fim: this.dt_emi_fim,
        hr_imp_fim: this.hr_imp_fim,
        emi_cnpj: this.emi_cnpj,
        des_cnpj: this.des_cnpj,
        status_importacao: this.status_importacao,
        chave: this.chave,
        status: this.status,
        tp_pessoa: this.tp_pessoa,
        municipio: this.municipio,
        fornecedor: this.fornecedor
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.nf_ini = "";
      this.nf_fim = "";
      this.serie = "";
      this.emi_razao_social = "";
      this.red_razao_social = "";
      this.usuario_imp = "";
      this.dt_imp_ini = "";
      this.dt_imp_fim = "";
      this.dt_emi_ini = "";
      this.hr_imp_ini = "";
      this.dt_emi_fim = "";
      this.hr_imp_fim = "";
      this.emi_cnpj = "";
      this.des_cnpj = "";
      this.status_importacao = "";
      this.chave = "";
      this.status = "";
      this.tp_pessoa = "";
      this.municipio = "";
      this.fornecedor = "";
      this.$events.fire("filter-reset");
    },
    validateDates() {
      this.dateValidationError = "";
      if (this.dt_imp_ini && this.dt_imp_fim) {
        const startStr = `${this.dt_imp_ini} ${this.hr_imp_ini || "00:00:00"}`;
        const endStr = `${this.dt_imp_fim} ${this.hr_imp_fim || "23:59:59"}`;

        const start = moment(startStr, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"]);
        const end = moment(endStr, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"]);

        if (start.isValid() && end.isValid() && start.isAfter(end)) {
          this.dateValidationError =
            "Data e Hora Inicial não pode ser maior que Data e Hora Final";
        }
      }
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      }
    },
    timeState() {
      return this.dateValidationError ? false : null;
    }
  }
};
</script>
